// Check for single post category and highlight menu item.
declare const postCategory: string;

document.addEventListener("DOMContentLoaded", function (event) {
  if (typeof postCategory !== "undefined") {
    // console.log(postCategory);
    switch (postCategory) {
      case "news":
      case "video":
        document.querySelector("li#menu-item-1743")?.classList.add("current-menu-item");
        break;
      case "statements":
        document.querySelector("li#menu-item-2257")?.classList.add("current-menu-item");
        document.querySelector("li#menu-item-1758")?.classList.add("current-menu-item");
        break;
      case "briefings":
        document.querySelector("li#menu-item-2257")?.classList.add("current-menu-item");
        document.querySelector("li#menu-item-2076")?.classList.add("current-menu-item");
        break;
      case "events":
        document.querySelector("li#menu-item-2257")?.classList.add("current-menu-item");
        document.querySelector("li#menu-item-1740")?.classList.add("current-menu-item");
        break;
      case "podcasts":
        document.querySelector("li#menu-item-2257")?.classList.add("current-menu-item");
        document.querySelector("li#menu-item-2638")?.classList.add("current-menu-item");
        break;
      case "speeches":
        document.querySelector("li#menu-item-2257")?.classList.add("current-menu-item");
        document.querySelector("li#menu-item-4220")?.classList.add("current-menu-item");
        break;
      default:
        break;
    }
  }
});

// Scroll to top.
document.addEventListener("DOMContentLoaded", function (event) {
  document.addEventListener("click", function (event) {
    if ((event.target as HTMLElement)?.id === "back-to-top") {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  });
});

// Search box events - search and reset.
document.addEventListener("DOMContentLoaded", function (event) {
  const urlProtocol = window.location.protocol;
  const urlHost = window.location.host;
  const urlPath = window.location.pathname.split("/");

  // Search reset.
  const searchReset = document.getElementById("search-reset");
  if (searchReset) {
    searchReset.addEventListener("click", (event) => {
      event.preventDefault();
      const pageUrl = urlProtocol + "//" + urlHost + "/" + urlPath[1] + "/";
      if (pageUrl) {
        window.location.href = pageUrl;
      }
      return false;
    });
  }

  // Search submit.
  const searchSubmit = document.getElementById("search-submit");
  if (searchSubmit) {
    searchSubmit.addEventListener("click", (event) => {
      event.preventDefault();

      const searchKey = document.getElementById("key") as HTMLInputElement;
      let pageUrl = "";
      if (searchKey?.value) {
        pageUrl = urlProtocol + "//" + urlHost + "/" + urlPath[1] + "/?key=" + searchKey.value;
      } else {
        pageUrl = urlProtocol + "//" + urlHost + "/" + urlPath[1] + "/";
      }
      if (pageUrl) {
        window.location.href = pageUrl;
      }
      return false;
    });
  }
});

// Initialize carousel
jQuery(function ($) {
  $(function () {
    let urlHost = window.location.host;
    let urlBase = urlHost.split(".");

    // Return if not home page.
    if (window.location.pathname != "/") {
      return;
    }

    // Set autoPlay
    let carouselPlay;
    urlBase[1] == "testi" || urlBase[0] == "localhost:3000"
      ? (carouselPlay = false)
      : (carouselPlay = true);

    // Run carousel on home page.
    const owlCarouselDom = document.querySelector(".owl-carousel");
    if (owlCarouselDom) {
      ($(owlCarouselDom) as any).owlCarousel({
        items: 1,
        loop: true,
        mouseDrag: true,
        touchDrag: true,
        navigation: false,
        autoplay: carouselPlay,
        autoplayTimeout: 6000,
        autoplayHoverPause: true,
        autoplaySpeed: 1200,
        dotsSpeed: 1200,
      });
    }
  });
});
